import { themes } from "prism-react-renderer";

export const codeTheme = {
  ...themes.vsDark,
  plain: {
    color: "var(--color-code-text)",
    backgroundColor: "var(--color-code-bg)",
  },
  styles: [
    { types: ["comment", "prolog", "doctype", "cdata"], style: { color: "var(--color-code-comment)" } },
    { types: ["string", "attr-value"], style: { color: "var(--color-code-string)" } },
    { types: ["keyword", "atrule"], style: { color: "var(--color-code-keyword)" } },
    { types: ["function", "method"], style: { color: "var(--color-code-function)" } },
    { types: ["tag", "selector"], style: { color: "var(--color-code-tag)" } },
    { types: ["attr-name"], style: { color: "var(--color-code-attr)" } },
    { types: ["number", "boolean"], style: { color: "var(--color-code-number)" } },
    { types: ["operator", "arrow"], style: { color: "var(--color-code-operator)" } },
    { types: ["punctuation"], style: { color: "var(--color-code-punctuation)" } },
    { types: ["class-name", "maybe-class-name"], style: { color: "var(--color-code-class)" } },
    { types: ["builtin", "constant"], style: { color: "var(--color-code-builtin)" } },
    { types: ["property"], style: { color: "var(--color-code-key)" } },
    { types: ["plain"], style: { color: "var(--color-code-text)" } },
  ],
};
